import BreadCrumb from '@medical/components/Breadcrumb'
import ConfirmationModal from '@medical/components/ConfirmationModal'
import Router from '@medical/routes/router'
import { Formik } from 'formik'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import ModalLink from '../../../../components/ModalLink'

const StaffGroupsListScene = ({
  i18n,
  staffGroups,
  onSubmit,
  isCreatePermitted,
  isDeletePermitted,
  isUpdatePermitted,
  location,
  refetch,
}) => {
  const [selectedGroup, setSelectedGroup] = useState(null)
  const prevPathnameRef = useRef(location.pathname)

  useEffect(() => {
    const prevPathname = prevPathnameRef.current
    prevPathnameRef.current = location.pathname
    if (prevPathname !== location.pathname && prevPathname.length > location.pathname.length) {
      refetch().then(({ data }) => {
        if (selectedGroup && data) {
          const updatedGroup = data.staffGroups.find(g => g.id === selectedGroup.id)
          if (updatedGroup) {
            setSelectedGroup({ id: updatedGroup.id, name: updatedGroup.name, staffList: updatedGroup.staffList })
          }
        }
      })
    }
  }, [location.pathname])
  return (
  <React.Fragment>
    <div className='staff-header'>
      <div className='staff-title'>
        {i18n.t('staff.menuBar.staffGroups')}
        <BreadCrumb items={[{ title: i18n.t('staff.menuBar.staffGroups') }]} />
      </div>
      {isCreatePermitted ? (
        <div className='staff-buttons'>
          <Link to={Router.staffGroupCreate}>
            <Button
              label={i18n.t('staff.staffGroup.create')}
              icon='pi pi-plus'
              className='p-button-normal'
            />
          </Link>
        </div>
      ) : null}
    </div>
    <div className='container is-medium'>
      <div className='box'>
        <Formik
          initialValues={{
            staffGroupId: '',
            confirm: false,
          }}
          onSubmit={onSubmit}
          render={formikProps => (
            <React.Fragment>
              <table className='table'>
                <thead>
                  <tr>
                    <th>{i18n.t('main.groupName')}</th>
                    {isUpdatePermitted || isDeletePermitted ? (
                      <th width='140px'>{i18n.t('main.action')}</th>
                    ) : null}
                  </tr>
                </thead>
                <tbody>
                  {staffGroups.map(({ id, name, staffList }) => (
                    <tr key={id}>
                      <td>{name}</td>
                      {isUpdatePermitted || isDeletePermitted ? (
                        <td>
                          <div className='action'>
                            <Button
                              icon='pi pi-user'
                              onClick={() => setSelectedGroup({ id, name, staffList })}
                            />
                            {isUpdatePermitted ? (
                              <Link
                                to={Router.get(Router.staffGroupDetail, {
                                  staffGroupId: id,
                                })}
                              >
                                <Button icon='pi pi-pencil' />
                              </Link>
                            ) : null}
                            {isDeletePermitted ? (
                              <Button
                                onClick={() => {
                                  formikProps.setFieldValue('staffGroupId', id)
                                  formikProps.setFieldValue('confirm', true)
                                }}
                                icon='pi pi-trash'
                              />
                            ) : null}
                          </div>
                        </td>
                      ) : null}
                    </tr>
                  ))}
                </tbody>
              </table>
              <ConfirmationModal
                {...formikProps}
                confirmationMessage={i18n.t(
                  'staff.staffGroup.deleteConfirmation'
                )}
              />
            </React.Fragment>
          )}
        />
      </div>
    </div>
    <Dialog
      header={selectedGroup ? selectedGroup.name : ''}
      visible={!!selectedGroup}
      style={{ width: '600px' }}
      onHide={() => setSelectedGroup(null)}
    >
      {selectedGroup && (
        <table className='table'>
          <thead>
            <tr>
              <th>{i18n.t('updateProfile.fullname')}</th>
              <th>{i18n.t('updateProfile.email')}</th>
              <th>{i18n.t('updateProfile.position')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {selectedGroup.staffList && selectedGroup.staffList.length > 0 ? (
              selectedGroup.staffList.map(staff => (
                <tr key={staff.id}>
                  <td>{`${staff.lastname} ${staff.firstname}`}</td>
                  <td>{staff.email}</td>
                  <td>{staff.position}</td>
                  <td>
                    <ModalLink
                      to={Router.get(Router.staffStaffDetail, {
                        staffId: staff.id,
                      })}
                    >
                      <Button icon='pi pi-info' />
                    </ModalLink>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2} style={{ textAlign: 'center' }}>
                  データがありません
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </Dialog>
  </React.Fragment>
  )
}

export default StaffGroupsListScene
